import { FC } from 'react'
import { Button, cn } from '@wellesley/ui'
import { Group, MembershipState } from '@wellesley/openapi'
import { AppsLink, AppsRoutes } from '@wellesley/router'

type JoinButtonProps = {
  group: Pick<Group, 'groupName' | 'joinMode'>
  membershipState?: MembershipState
  onJoin: (e: React.MouseEvent) => void
  onVisit?: () => void
  onCancelRequest: (e: React.MouseEvent) => void
  className?: string
  inviteLink?: boolean
}

export const JoinButton: FC<JoinButtonProps> = ({
  group,
  inviteLink,
  onJoin,
  onVisit,
  membershipState,
  onCancelRequest,
  className,
}) => {
  if (membershipState === 'MEMBER') {
    return (
      <Button
        variant="primary"
        size="s"
        asChild
        className={cn(
          `flex w-full flex-1 items-center justify-center gap-xxs`,
          className,
        )}
        dataTestId="visit-group-button"
      >
        <AppsLink
          to={'/g/:groupname' as AppsRoutes}
          props={{ groupname: group.groupName }}
          onClick={onVisit}
        >
          Visit group
        </AppsLink>
      </Button>
    )
  }

  if (membershipState === 'PENDING_JOIN') {
    return (
      <Button
        variant="secondary_danger"
        size="s"
        className={cn(
          `flex w-full flex-1 items-center justify-center gap-xxs`,
          className,
        )}
        onClick={onCancelRequest}
        dataTestId="cancel-request-button"
      >
        Cancel request
      </Button>
    )
  }

  if (group.joinMode === 'INVITE_ONLY') {
    if (inviteLink) {
      return (
        <Button
          variant="primary"
          size="s"
          className={cn(
            `flex w-full flex-1 items-center justify-center gap-xxs`,
            className,
          )}
          onClick={onJoin}
          dataTestId="join-button"
        >
          Join
        </Button>
      )
    }
    return (
      <div
        className={cn(
          `flex items-center justify-center gap-xxs px-s py-xxs text-base font-semibold text-gray-500`,
          className,
        )}
        data-testid="join-by-invite-button"
      >
        Join by invite
      </div>
    )
  }

  return (
    <Button
      variant="primary"
      size="s"
      className={cn(`flex w-full flex-1`, className)}
      onClick={onJoin}
      dataTestId="join-request-button"
    >
      {group.joinMode === 'OPEN' ? 'Join' : 'Send join request'}
    </Button>
  )
}
